var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.styleClass,attrs:{"type":"text","id":_vm.active ? _vm.Style : 'login_input',"placeholder":_vm.textpl},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }